export default function MessagesIndex() {
    return (
        <div className="flex-1 flex items-center justify-center text-muted-foreground">
            <p>Select a conversation on the left</p>
        </div>
    );
}